import React from "react";
import { Link } from "react-router-dom";
import "./GetApp.css";

function GetApp() {
    return (
        <div className="get-app-container">
            <div className="download-section">
                <h1>Get Click-n-Learn Mobile</h1>
                <div className="download-options">
                    <div className="download-card">
                        <i className="fab fa-android"></i>
                        <h2>Android</h2>
                        <a
                            href="https://play.google.com/store/apps/details?id=com.legacyatsea.clicknlearn"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="/GetItOnGooglePlay_Badge_Web_color_English.png"
                                alt="Get it on Google Play"
                                style={{ height: "60px" }}
                            />
                        </a>{" "}
                    </div>
                    <div className="download-card coming-soon">
                        <i className="fab fa-apple"></i>
                        <h2>iOS</h2>
                        <div className="coming-soon-text">Coming Soon</div>
                        <p style={{ marginTop: '15px', fontSize: '1rem', lineHeight: '1.4', color: '#555' }}>
                            We hope to have it available soon for iOS. If that's something that interests you, send us a note on the <Link to="/feedback" style={{ color: '#00796b', textDecoration: 'underline' }}>contact form</Link> and we'll let you know as soon as it's available!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GetApp;
